// Qué significa que un token esté vivo, y cómo se ordena la lista.
//
// DOS FORMAS DE ESTAR MUERTO, Y NO SON LA MISMA.
//
//   · Revocado: `status` 0. Alguien lo apagó. La fila se conserva porque las
//     tareas y los eventos que firmó siguen apuntando a algo que existe.
//   · Vencido: `expires_at` en el pasado, con `status` todavía en 2. Nadie hizo
//     nada; simplemente dejó de autenticar.
//
// Un token vencido que se mostrara como «Activo» es el que alguien va a pasar
// media hora depurando del lado del agente. Por eso son dos lecturas y el verde
// solo lo lleva el que de verdad puede autenticar hoy.

export function isRevoked(token) {
    return token.status === 0;
}

// `at` es el reloj contra el que se juzga: cuándo se pidió la lista, no cuándo
// React repintó. Leer `Date.now()` en render es impuro y volteaba un token de
// vivo a vencido en un repintado que no tenía nada que ver.
export function isExpired(token, at) {
    return !!token.expires_at && Date.parse(token.expires_at) <= at;
}

export function isLive(token, at) {
    return token.status === 2 && !isExpired(token, at);
}

// «Inactivo» para la pantalla es todo lo que ya no autentica: revocado,
// vencido, o `status` 1. Esconderlos por defecto es lo correcto porque una
// credencial muerta no es una decisión pendiente — pero esconderlos en silencio
// no lo es, y por eso la lista dice cuántos dejó afuera.
export function isDormant(token, at) {
    return !isLive(token, at);
}

export const SORTS = [
    { value: '',        label: 'Último uso: más reciente' },
    { value: 'oldest',  label: 'Último uso: más antiguo' },
    { value: 'created', label: 'Emisión: más reciente' },
];

// `last_used_at` ES NULO HASTA QUE EL TOKEN SE USA, y ese nulo no es una fecha
// cero: significa «nunca». Ordenar tratándolo como 0 manda los nunca usados al
// fondo cuando se pide «más reciente», que es donde deberían estar — pero al
// FRENTE cuando se pide «más antiguo», donde no dicen nada. Así que los nunca
// usados van siempre al final, en los dos sentidos, y se los lee como el grupo
// aparte que son.
export function sortTokens(tokens, sort) {
    const key = sort === 'created' ? 'createdAt' : 'last_used_at';
    const direction = sort === 'oldest' ? 1 : -1;

    const stamp = (token) => {
        const raw = token[key] ?? (key === 'createdAt' ? token.created_at : null);
        const time = raw ? Date.parse(raw) : NaN;
        return Number.isNaN(time) ? null : time;
    };

    return [...tokens].sort((a, b) => {
        const left = stamp(a);
        const right = stamp(b);

        // Sin fecha al final, siempre.
        if (left === null && right === null) return a.id - b.id;
        if (left === null) return 1;
        if (right === null) return -1;

        // Desempate por id: dos tokens del mismo segundo no cambian de lugar
        // entre dos renders.
        return left === right ? a.id - b.id : (left - right) * direction;
    });
}
